import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { VacationRequestService } from '../../../../../core/services/vacation-request.service';
import { PersonalService } from '../../../../../core/services/personal.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-personal-vacation-request',
  templateUrl: './personal-vacation-request.component.html',
  imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgxPaginationModule],
  styleUrls: ['./personal-vacation-request.component.css']
})
export class PersonalVacationRequestComponent {
  buttonsPermission: any;
  search_text = '';
  data: any[] = [];
  personals: any[] = [];
  selected_data: any;
  loading = false;

  form: any = this.emptyForm();
  decision_note = '';

  readonly TYPES = ['annuel', 'maladie', 'maternité', 'exceptionnel', 'sans solde'];

  pg = { pageSize: 10, p: 0, total: 0 };

  constructor(
    private vacationService: VacationRequestService,
    private personalService: PersonalService,
    private toastrService: ToastrService,
    config: NgbModalConfig,
    private modalService: NgbModal
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.buttonsPermission = { show: true, add: true, edit: true, delete: true, status: true };
    this.getAll();
    this.getPersonals();
  }

  emptyForm() {
    return { personal_id: null, type: 'annuel', start_date: new Date().toISOString().substring(0, 10), end_date: new Date().toISOString().substring(0, 10), reason: '' };
  }

  getAll() {
    this.loading = true;
    this.vacationService.getAll().subscribe((res: any) => {
      this.loading = false;
      this.data = res.data ?? [];
      this.pg.total = this.data.length;
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion des congés', err); });
  }

  getPersonals() {
    this.personalService.getAll().subscribe((res: any) => { this.personals = res.data ?? []; }, () => {});
  }

  store(value: any) {
    this.loading = true;
    this.vacationService.store(value).subscribe((res: any) => {
      this.loading = false;
      this.toastrService.success(res.message);
      this.modalService.dismissAll();
      this.form = this.emptyForm();
      this.getAll();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion des congés', err); });
  }

  update(value: any) {
    this.loading = true;
    this.vacationService.update(this.selected_data.id, value).subscribe((res: any) => {
      this.loading = false;
      this.toastrService.success(res.message);
      this.modalService.dismissAll();
      this.getAll();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion des congés', err); });
  }

  delete() {
    if (!this.verifyChecked()) return;
    const confirmed = AppSweetAlert.confirmBox('info', 'Suppression', 'Voulez-vous vraiment supprimer cette demande ?');
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.vacationService.delete(this.selected_data.id).subscribe((res: any) => {
          this.toastrService.success(res.message);
          this.getAll();
        }, (err: any) => AppErrorShow.showError('Gestion des congés', err));
      }
    });
  }

  decide(state: any) {
    if (!this.verifyChecked()) return;
    this.loading = true;
    this.vacationService.decide(this.selected_data.id, state, this.decision_note).subscribe((res: any) => {
      this.loading = false;
      this.toastrService.success(res.message);
      this.modalService.dismissAll();
      this.getAll();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion des congés', err); });
  }

  checked(el?: any) { this.selected_data = el; }

  verifyChecked() {
    if (this.selected_data == null) { this.toastrService.warning('Aucun élément sélectionné'); return false; }
    return true;
  }

  add(content: any) {
    this.form = this.emptyForm();
    this.modalService.open(content, { size: 'lg' });
  }

  edit(content: any) {
    if (!this.verifyChecked()) return;
    this.form = { ...this.selected_data };
    this.modalService.open(content, { size: 'lg' });
  }

  show(content: any) {
    if (!this.verifyChecked()) return;
    this.decision_note = this.selected_data.decision_note ?? '';
    this.modalService.open(content, { size: 'lg' });
  }

  dismiss() { this.modalService.dismissAll(); }

  getPage(event: any) { this.pg.p = event; }

  personalName(p: any) { return p ? `${p.lastname} ${p.firstname}` : '—'; }

  statusLabel(s: number) { return s == 1 ? 'Approuvé' : (s == 2 ? 'En attente' : 'Refusé'); }
  statusClass(s: number) { return s == 1 ? 'bg-green-100 text-green-700' : (s == 2 ? 'bg-orange-100 text-orange-700' : 'bg-red-100 text-red-700'); }
}
